// src/ParentTestimonialsCarousel.js

import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Static testimonials data
const testimonials = [
  {
    id: '1',
    name: 'Brandon Williams',
    quote:
      "Our first experience with travel hockey was with the Glass City Gladiators. While we were nervous to embark on the youth travel hockey journey, the coaches put us at ease very quickly. The coaching staff and their provided instruction were top notch and exactly what our son needed. The schedule was a good mix of games and tournaments, both local and regional, allowing for a competitive experience - but not overwhelming our family schedule. We would highly recommend the Glass City Gladiators to anyone looking for a youth travel hockey program that is competitive as well as budget and family friendly. Our entire family has created long-lasting friendships through the Glass City Gladiators and we couldn’t be more thankful."
  },
  {
    id: '2',
    name: 'Ben and Ashley Kinkaid',
    quote:
      "As parents, we always hoped our child would find a team that was more than just a group of players - a team that felt like a family. From the moment he joined the Glass City Gladiators, we knew we had found something special. The dedication of the coaches, the camaraderie among the players, and the unwavering support from fellow families created an environment where our son could thrive, not just as an athlete, but as a person. We've watched him grow in confidence, develop resilience, and learn the true meaning of teamwork. Every practice, every game, and every challenge he faced on the ice was met with encouragement and guidance that extended beyond the rink. The Gladiators are not just about hockey; they are also about building character, fostering friendships, and creating lifelong memories. We're beyond grateful to be part of such a phenomenal organization!"
  },
  {
    id: '3',
    name: 'Jon Ziehr',
    quote:
      "Hockey is more to our family than just our son “making the team”. We wanted discipline, leadership, compassion, team and family bonding, development, and enjoyment for the game… Glass City Gladiators Hockey Program encompasses that and more. The coaches bring the dedication and expertise, the families bring love. We wouldn’t want it any other way."
  },
  {
    id: '4',
    name: 'The Brossia Family',
    quote:
      "We’ve had a fantastic experience with the Glass City Gladiators this season. Coach Mickey, Rusty, James and Jason are supportive, knowledgeable, and truly care about the kids’ development both on and off the ice. Blake has grown so much in skill and confidence, and we’re grateful to be part of such a positive and encouraging hockey family."
  },
  {
    id: '5',
    name: 'Bradley Lenz',
    quote: `The Glass City Gladiators' knowledge of improving hockey performance has helped my son in ways I didn’t know existed when they first started working together.

In just one year of training with him, my son’s strength and speed have improved dramatically.

The GCG have a great coaching staff that help reach a new level in the sport. They have a unique way of training the players and an individual approach to each one of them. The experience and knowledge in hockey is very visible when you see them work on ice.`
  },
  {
    id: '6',
    name: 'Stefany Forkapa',
    quote: `Being a part of the Gladiator family has been a great experience for us! The coaches truly care about the players and their development, working hard to ensure the kids have plenty of ice time and opportunity to participate in several tournaments. I’ve seen tremendous growth in my son, both on and off the ice, and would recommend the Gladiators to any hockey family!`
  }
];

const ParentTestimonialsCarousel = () => {
  return (
    <Carousel
      infiniteLoop
      showArrows={false}
      showThumbs={false}
      showStatus={false}
      dynamicHeight={true}  // each slide will size to its content
      swipeable
      emulateTouch
    >
      {testimonials.map(t => (
        <div
          key={t.id}
          style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}
        >
          <blockquote
            style={{
              color: '#ddd',
              fontStyle: 'italic',
              fontSize: '1.1rem',
              lineHeight: 1.5,
              marginBottom: '10px'
            }}
          >
            “{t.quote}”
          </blockquote>
          <p style={{ color: '#B4975A', fontWeight: 'bold' }}>— {t.name}</p>
        </div>
      ))}
    </Carousel>
  );
};

export default ParentTestimonialsCarousel;
